var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDailyFlowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-1 0 0 1 48 0)",
    fill: "#E2FFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2953 21.8465C15.7971 23.6291 15.9323 25.5292 16.678 27.2232C17.4237 28.9172 18.7337 30.3002 20.3848 31.1366C22.0359 31.973 23.9259 32.211 25.7328 31.8101C27.5397 31.4092 29.1517 30.3942 30.2941 28.938C30.635 28.5035 31.2636 28.4276 31.6982 28.7685C32.1327 29.1094 32.2086 29.738 31.8677 30.1725C30.4396 31.9928 28.4246 33.2615 26.166 33.7626C23.9074 34.2637 21.5448 33.9662 19.481 32.9207C17.4172 31.8752 15.7797 30.1464 14.8475 28.029C13.9154 25.9115 13.7463 23.5363 14.3691 21.3082C14.9919 19.08 16.368 17.1367 18.2629 15.8094C20.1578 14.4821 22.4544 13.8529 24.7612 14.029C27.0681 14.2051 29.2425 15.1757 30.914 16.7752C31.2304 17.078 31.525 17.3998 31.7968 17.7381L32.4088 16.0008C32.5049 15.728 32.7143 15.5102 32.9831 15.4035L34 15V23L33.9351 22.9351C33.9289 23.4285 33.5583 23.8532 33.055 23.914C32.5067 23.9802 32.0085 23.5894 31.9423 23.0411C31.7205 21.2036 30.8684 19.4999 29.5312 18.2202C28.194 16.9405 26.4545 16.1641 24.609 16.0232C22.7635 15.8823 20.9263 16.3857 19.4103 17.4475C17.8944 18.5094 16.7935 20.064 16.2953 21.8465ZM23.4999 18H24.9999L25.4074 23.7056L29.0001 26.5L27.94 27.5841L24.0575 25.1601C23.9447 25.0897 23.8516 25.0011 23.7791 24.901C23.345 24.7088 23.0528 24.2594 23.089 23.7532L23.4999 18Z",
    fill: "#14C6BB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyFlowIcon);
export default __webpack_public_path__ + "static/media/daily-flow-icon.ce82fd6ed0ffa0319c8f06071c7703fe.svg";
export { ForwardRef as ReactComponent };